<template>

</template>

<script>
import SearchBar from '@/components/libraries/SearchBar';

export default {
  name: 'LibrarySearch',
  components: { SearchBar }
};
</script>

<style scoped>
  .search-bar {
    width: 100%;
  }
</style>